var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49373",
    "data-name": "Group 49373",
    transform: "translate(-10475 6321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4850",
    "data-name": "Ellipse 4850",
    transform: "translate(10477.782 -6313.348)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.783,
    cy: 2.783,
    r: 2.783,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.783,
    cy: 2.783,
    r: 1.783,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4851",
    "data-name": "Ellipse 4851",
    transform: "translate(10479.869 -6306.391)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4852",
    "data-name": "Ellipse 4852",
    transform: "translate(10476.392 -6307.783)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4853",
    "data-name": "Ellipse 4853",
    transform: "translate(10483.348 -6307.783)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4854",
    "data-name": "Ellipse 4854",
    transform: "translate(10475 -6311.261)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4855",
    "data-name": "Ellipse 4855",
    transform: "translate(10484.739 -6311.261)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4856",
    "data-name": "Ellipse 4856",
    transform: "translate(10476.392 -6314.739)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4857",
    "data-name": "Ellipse 4857",
    transform: "translate(10479.869 -6316.13)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4874",
    "data-name": "Ellipse 4874",
    transform: "translate(10482.652 -6318.217)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.783,
    cy: 2.783,
    r: 2.783,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.783,
    cy: 2.783,
    r: 1.783,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4875",
    "data-name": "Ellipse 4875",
    transform: "translate(10484.739 -6311.261)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4877",
    "data-name": "Ellipse 4877",
    transform: "translate(10488.218 -6312.652)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4878",
    "data-name": "Ellipse 4878",
    transform: "translate(10479.869 -6316.13)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4879",
    "data-name": "Ellipse 4879",
    transform: "translate(10489.608 -6316.13)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4880",
    "data-name": "Ellipse 4880",
    transform: "translate(10481.261 -6319.609)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4881",
    "data-name": "Ellipse 4881",
    transform: "translate(10484.739 -6321)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4882",
    "data-name": "Ellipse 4882",
    transform: "translate(10488.218 -6319.609)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.696,
    cy: 0.696,
    r: 0.196,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirus);
export default __webpack_public_path__ + "static/media/virus.efb3132832c61f58523d0a44d5ea6ff5.svg";
export { ForwardRef as ReactComponent };